module.exports = __webpack_public_path__ + "static/media/app-1.34451b3f.svg";